// Inscription is handled on the external Elitechip platform. The in-app
// RegisterModal is disabled for now — every "Inscríbete" / "Inscripción" CTA
// links straight here. Re-introduce the modal by pointing CTAs back at it.
export const REGISTRATION_URL =
  'https://www.elitechip.net/index.php?zwshow=compdet&idcomp=7380266'
